import React, { useEffect } from "react";
import "react-table-v6/react-table.css";
import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import { Card, Col, Container, Image, Row, Table } from "react-bootstrap";
import {
  useHistory,
  //   useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { connect } from "react-redux";
import delivaApiService from "../../../common/services/apiService";
import Loader from "../../../Component/common/Loader";
import moment from "moment";
import Footer from "../commonAdmin/Footer";
import {
  getCurrencySymbol,
  getStatusClassName,
} from "../../../common/helpers/Utils";
import CancelRequestOrderModal from "./CancelRequestOrderModal";

const OpenDeliveryRequestsDetails = (props) => {
  const { countries } = props;
  const [showLoader, setShowLoader] = React.useState(false);
  const [bidsData, setBidsData] = React.useState(null);
  const [requestDetails, setRequestDetails] = React.useState(null);
  const [showCancelRequest, setShowCancelRequest] = React.useState(false);
  const [cancelReason, setCancelReason] = React.useState("");

  // hooks
  const history = useHistory();
  //get order id from params
  const { id } = useParams();

  // Open Delivery Request Data
  const getOpenDeliveryRequestData = (id) => {
    delivaApiService("getOpenDeliveryRequestDetail", { orderId: id })
      .then((response) => {
        if (response?.data?.status === 200) {
          const data = response?.data?.resourceData;
          setRequestDetails(data);
          setShowLoader(false);
        }
      })
      .catch((error) => {
        setShowLoader(false);
        console.error("Failed to update status:", error);
      });
  };

  // Get all bids data for request
  const getAllBidsData = (id) => {
    delivaApiService("getAllBidsForRequest", { orderId: id })
      .then((response) => {
        setShowLoader(false);
        if (response?.data?.status === 200) {
          const data = response?.data?.resourceData;
          setBidsData(data);
          console.log(data, response, "all bids for request data");
        }
      })
      .catch((error) => {
        setShowLoader(false);
        console.error("Failed to update status:", error);
      });
  };

  const handleShowCancelRequest = () => {
    setShowCancelRequest(true);
  };

  const handleCloseCancelRequest = () => {
    setShowCancelRequest(false);
  };

  useEffect(() => {
    if (id) {
      setRequestDetails(null);
      setBidsData(null);
      setShowLoader(true);
      getOpenDeliveryRequestData(id);
      getAllBidsData(id);
    }
  }, [id]);

  // const getCurrencyParts = (currencyString) => {
  //   const match = currencyString.match(/^(.+?)\s*\((.+?)\)$/);
  //   if (match) {
  //     return {
  //       name: match[1].trim(), // "Nigerian naira"
  //       symbol: match[2].trim(), // "₦"
  //     };
  //   }
  //   return {
  //     name: currencyString,
  //     symbol: "",
  //   };
  // };

  // const currencyParts = getCurrencyParts(requestDetails?.currency || "");

  const formatPhoneNumber = (num) => {
    // Remove all non-digits except +
    num = num.replace(/[^+\d]/g, "");

    // Extract country code (+234) and remaining digits
    const country = num.slice(0, 4); // +234
    const rest = num.slice(4); // 5868658565

    // Format groups: 3 - 3 - 4
    const part1 = rest.slice(0, 3);
    const part2 = rest.slice(3, 6);
    const part3 = rest.slice(6);

    return `${country} ${part1} ${part2} ${part3}`;
  };

  const handleCancelReason = (reason) => {
    setCancelReason(reason);
  };

  const cancelDeliveryOrder = () => {
    setShowLoader(true);
    delivaApiService("cancelDeliveryRequest", {
      requestId: id,
      deliveryRequestReason: [cancelReason],
      canceled: true,
    })
      .then((response) => {
        if (response?.data?.status === 200) {
          handleCloseCancelRequest();
          history.push({
            pathname: `/opendeliveryrequests`,
          });
        }
        setShowLoader(false);
      })
      .catch((error) => {
        setShowLoader(false);
        console.error("Failed to update status:", error);
      });
  };

  return (
    <div className="page__wrapper h-100">
      <Header {...props} />
      <div className="mainContainer CustomerTable">
        <Row noGutters className="h-100">
          <Sidebar {...props} />
          <Col md={9} lg={10} className="boxTyp3">
            <Container fluid>
              <div className="content-wrapper">
                <section className="d-flex justify-content-between align-items-center gap-1 mb-4">
                  <div className="w-100">
                    <h3 className="font-weight-normal mb-0 line-ht color-33 fs-24">
                      Details of Open Delivery
                    </h3>
                    <h5 className="font-weight-normal mb-0 line-ht color-head">
                      <span
                        className="pointer"
                        onClick={() =>
                          history.push({
                            pathname: `/opendeliveryrequests`,
                          })
                        }
                      >
                        List of Open delivery request
                      </span>
                      <span className="icon-next mx-2 fs12"></span>
                      <span className="pointer">
                        Open Delivery Request Details{" "}
                      </span>
                    </h5>
                  </div>

                  <button
                    className="df-button danger cancel-red-btn"
                    onClick={handleShowCancelRequest}
                  >
                    {"Cancel Request"}
                  </button>
                </section>
                <section className="details-wrap mb-4">
                  <Row noGutters>
                    <Col md={12} lg={12}>
                      <>
                        <h5 className="px-3 px-md-4">{"Package details"}</h5>
                        <hr />
                      </>
                    </Col>
                  </Row>
                  <>
                    <Row className="px-3 px-md-4">
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Title
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.title ? requestDetails?.title : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Weight
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.weight
                            ? requestDetails?.weight
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Package Value
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.value
                            ? `${getCurrencySymbol(requestDetails?.currency, countries)}${requestDetails?.value}`
                            : "--"}
                        </p>
                      </Col>

                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Offer Amount
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.bidAmount
                            ? `${getCurrencySymbol(requestDetails?.currency, countries)}${requestDetails?.bidAmount}`
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={12} lg={12} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Package Preview
                        </h5>
                        <div className="mt-4 d-flex flex-wrap gap-3">
                          {requestDetails?.requestMediaUrls?.map(
                            (imageObj, idx) => {
                              return (
                                <div
                                  style={{ width: "100%", maxWidth: "140px" }}
                                  key={idx}
                                >
                                  <Card
                                    className="card-id mb-4"
                                    style={{
                                      width: "100%",
                                      height: "140px",
                                    }}
                                  >
                                    <Card.Body>
                                      <Image
                                        className="img-fluid"
                                        width={140}
                                        height={140}
                                        src={imageObj?.originalMediaUrl}
                                      />
                                    </Card.Body>
                                  </Card>
                                </div>
                              );
                            },
                          )}
                        </div>
                      </Col>
                    </Row>
                  </>
                </section>
                <section className="details-wrap mb-4">
                  <Row noGutters>
                    <Col md={12} lg={12}>
                      <>
                        <h5 className="px-3 px-md-4">{"Order details"}</h5>
                        <hr />
                      </>
                    </Col>
                  </Row>
                  <>
                    <Row className="px-3 px-md-4">
                      <Col xs={12} md={6} lg={6} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Request ID
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.requestId
                            ? `#${requestDetails?.requestId}`
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={6} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Order date
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.orderDate
                            ? moment(requestDetails?.orderDate).format(
                                "DD MMM YYYY",
                              )
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={6} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Source
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.sourceLocation
                            ? requestDetails?.sourceLocation
                            : "--"}
                        </p>
                      </Col>

                      <Col xs={12} md={6} lg={6} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Destination
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.destinationLocation
                            ? requestDetails?.destinationLocation
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Pickup date
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.pickupDate
                            ? moment(requestDetails?.pickupDate).format(
                                "DD MMM YYYY",
                              )
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Pickup time
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.pickupTime
                            ? moment(requestDetails?.pickupTime).format(
                                "h:mm A",
                              )
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Expected delivery date
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.expectedDeliveryDate
                            ? moment(
                                requestDetails?.expectedDeliveryDate,
                              ).format("DD MMM YYYY")
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Expected delivery time
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.expectedDeliveryTime
                            ? moment(
                                requestDetails?.expectedDeliveryTime,
                              ).format("h:mm A")
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={12} lg={12} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Additional Notes
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.description
                            ? requestDetails?.description
                            : "--"}
                        </p>
                      </Col>
                    </Row>
                  </>
                </section>
                <div className="d-flex gap-3 ">
                  <section className="details-wrap mb-4 flex-fill">
                    <Row noGutters>
                      <Col md={12} lg={12}>
                        <>
                          <h5 className="px-3 px-md-4">{"Sender details"}</h5>
                          <hr />
                        </>
                      </Col>
                    </Row>
                    <>
                      <Row className="px-3 px-md-4">
                        <Col xs={12} md={6} lg={3} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Sender name
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                            {requestDetails?.senderName
                              ? requestDetails?.senderName
                              : "--"}
                          </p>
                        </Col>
                        <Col xs={12} md={6} lg={7} className="mb-4">
                          <h5 className="font-weight-normal color-grey fs18">
                            Sender Contact
                          </h5>
                          <p className="fs18 font-weight-500 mb-0 gray-600">
                            {requestDetails?.senderContact
                              ? formatPhoneNumber(requestDetails?.senderContact)
                              : "--"}
                          </p>
                        </Col>
                      </Row>
                    </>
                  </section>
                  {requestDetails?.pickupName && (
                    <section className="details-wrap mb-4 ml-2 flex-fill">
                      <Row noGutters>
                        <Col md={12} lg={12}>
                          <>
                            <h5 className="px-3 px-md-4">{"Pickup details"}</h5>
                            <hr />
                          </>
                        </Col>
                      </Row>
                      <>
                        <Row className="px-3 px-md-4">
                          <Col xs={12} md={6} lg={3} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Pickup Name
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                              {requestDetails?.pickupName
                                ? requestDetails?.pickupName
                                : "--"}
                            </p>
                          </Col>
                          <Col xs={12} md={6} lg={7} className="mb-4">
                            <h5 className="font-weight-normal color-grey fs18">
                              Pickup Contact
                            </h5>
                            <p className="fs18 font-weight-500 mb-0 gray-600">
                              {requestDetails?.pickupMobile
                                ? formatPhoneNumber(
                                    requestDetails?.pickupMobile,
                                  )
                                : "--"}
                            </p>
                          </Col>
                        </Row>
                      </>
                    </section>
                  )}
                </div>
                <section className="details-wrap mb-4">
                  <Row noGutters>
                    <Col md={12} lg={12}>
                      <>
                        <h5 className="px-3 px-md-4">{"Receiver details"}</h5>
                        <hr />
                      </>
                    </Col>
                  </Row>
                  <>
                    <Row className="px-3 px-md-4">
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Receiver name
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600 text-capitalize">
                          {requestDetails?.receiverName
                            ? requestDetails?.receiverName
                            : "--"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={3} className="mb-4">
                        <h5 className="font-weight-normal color-grey fs18">
                          Receiver Contact
                        </h5>
                        <p className="fs18 font-weight-500 mb-0 gray-600">
                          {requestDetails?.receiverContactNo
                            ? formatPhoneNumber(
                                requestDetails?.receiverContactNo,
                              )
                            : "--"}
                        </p>
                      </Col>
                    </Row>
                  </>
                </section>
                <Row noGutters className="mb-3 align-items-center px-3 px-md-4">
                  <Col xs={12} md={4} lg={6} className="">
                    <h3 className="font-weight-normal mb-2 mb-lg-0 tertiary-color fs-24">
                      List of Delivery Partner BID{" "}
                      <span className="tertiary-color">
                        ({bidsData?.totalCount})
                      </span>
                    </h3>
                  </Col>
                </Row>

                <div className="row px-3 px-md-4">
                  <div className="col-sm-12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Name</th>
                          <th>Business name</th>
                          <th>Rating</th>
                          <th>Bid amount</th>
                          <th>Pickup date</th>
                          <th>Delivery date</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody className="ttl-order-table">
                        {bidsData?.bids?.length === 0 ? (
                          <tr>
                            <td colSpan={8} style={{ textAlign: "center" }}>
                              No Records Available
                            </td>
                          </tr>
                        ) : (
                          bidsData?.bids?.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td className="text-capitalize">{`#${item?.bidId}`}</td>
                                <td>{item?.name ? item?.name : "-"}</td>
                                <td className="text-capitalize">
                                  {item?.businessName
                                    ? item?.businessName
                                    : "-"}
                                </td>
                                <td>{item?.rating}</td>
                                <td className="">{`${getCurrencySymbol(requestDetails?.currency, countries)}${item?.bidAmount}`}</td>
                                <td className="">
                                  {item?.pickupDateAndTime
                                    ? moment(item?.pickupDateAndTime).format(
                                        "MMM, DD, YYYY | h:mm A",
                                      )
                                    : "-"}
                                </td>
                                <td className="">
                                  {item?.expectedDeliveryDateAndTime
                                    ? moment(
                                        item?.expectedDeliveryDateAndTime,
                                      ).format("MMM, DD, YYYY | h:mm A")
                                    : "-"}
                                </td>
                                <td
                                  className={getStatusClassName(
                                    item?.bidStatus,
                                  )}
                                >
                                  {item?.bidStatus ? item?.bidStatus : "-"}
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
                <Footer {...props} />
              </div>
            </Container>
          </Col>
        </Row>
      </div>
      <Loader showLoader={showLoader} />
      <CancelRequestOrderModal
        showCancelRequest={showCancelRequest}
        type={"request"}
        handleCloseCancelRequest={handleCloseCancelRequest}
        handleCancelReason={handleCancelReason}
        cancelDeliveryOrder={cancelDeliveryOrder}
      />
    </div>
  );
};

export default connect((state) => ({ countries: state.country.countries }))(
  OpenDeliveryRequestsDetails,
);
